import { t } from 'i18next';

export const getStatusName = (status: string, provider?: string): string => {
  switch (status) {
    case 'ACTIVE':
      return t('active');
    case 'PAUSED':
      return t('paused');
    case 'ERROR':
      return t('error');
    case 'DISABLED':
      return t('disabled');
    case 'PENDING':
      // For Looker Studio reports, show "Pending URL", for others just "PENDING"
      if (provider === 'LOOKER_STUDIO') {
        return t('pendingUrl');
      }
      return t('pending');
    default:
      return t('unknown');
  }
};

export const getStatusClass = (status: string): string => {
  switch (status) {
    case 'ACTIVE':
      return 'status-pill-active';
    case 'PAUSED':
      return 'status-pill-paused';
    case 'ERROR':
      return 'status-pill-error';
    case 'DISABLED':
      return 'status-pill-disabled';
    case 'PENDING':
      return 'status-pill-pending';
    default:
      return 'status-pill-unknown';
  }
};

export const getProviderName = (provider: string): string => {
  switch (provider) {
    case 'LOOKER_STUDIO':
      return t('lookerStudio');
    default:
      return t('unknown');
  }
};

export const getTypeName = (type: string): string => {
  switch (type) {
    case 'DAILY':
      return t('daily');
    case 'WEEKLY':
      return t('weekly');
    case 'MONTHLY':
      return t('monthly');
    case 'CUSTOM':
      return t('custom');
    default:
      return t('unknown');
  }
};
